export default __webpack_public_path__ + "static/media/annoying-weight-gain-map.0563ff9a.png";